import { ArrowUpRight, FileDown } from "lucide-react";
import { Reveal, GoldDivider } from "./Reveal";
import { PRODUCTS, WHATSAPP_LINK, SPEC_SHEET } from "../../data/site";
import { useLang } from "../../i18n/LanguageContext";

const Products = () => {
  const { t, lang } = useLang();
  const items = t.products.items;
  return (
    <section id="products" data-testid="products-section" className="bg-[#F3EEE6] py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal className="text-center">
          <p className="overline text-gold">{t.products.overline}</p>
          <h2 className="mt-2 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl">
            {t.products.title}
          </h2>
          <GoldDivider />
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          {items.map((p, i) => (
            <Reveal key={i} delay={i * 0.12} classname="h-full">
              <article
                data-testid={`product-card-${i}`}
                className="group flex h-full flex-col bg-cream shadow-[0_2px_0_rgba(197,160,89,0.25)] transition-shadow duration-500 hover:shadow-[0_10px_40px_rgba(44,33,20,0.15)]"
              >
                <div className="spotlight relative overflow-hidden">
                  <span className="absolute left-4 top-4 z-10 bg-forest/90 text-cream overline text-[0.6rem] px-3 py-1">
                    {p.tag}
                  </span>
                  <img
                    src={PRODUCTS[i].image}
                    alt={p.name}
                    className="h-72 w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
                <div className="flex flex-1 flex-col p-8">
                  <h3 className="font-serif text-2xl text-ink leading-tight">{p.name}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-clay">{p.text}</p>

                  <dl className="mt-6 space-y-2 border-t border-gold/25 pt-5">
                    {p.specs.map(([k, v]) => (
                   <div
                    key={k}
                    className="grid min-h-[32px] grid-cols-[100px_minmax(0,1fr)] items-start gap-4 text-sm"
                   >
                    <dt className="text-clay/80 leading-5">{k}</dt>
                    <dd className="min-w-0 font-medium text-ink text-right leading-5 break-words">
                       {v}
                   </dd>
                  </div>))}
                  </dl>

                  <a
                    data-testid={`product-enquire-${i}`}
                    href={WHATSAPP_LINK}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-auto inline-flex items-center justify-between border border-ink/80 px-6 py-4 overline text-ink transition-colors duration-300 hover:border-gold hover:bg-gold hover:text-white"
                  >
                    {t.common.enquire}
                    <ArrowUpRight className="h-4 w-4" />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-12 flex justify-center">
          <a
            data-testid="download-spec-sheet"
            href={SPEC_SHEET[lang]}
            download
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 bg-forest hover:bg-forest2 text-cream overline px-8 py-4 transition-colors duration-300"
          >
            <FileDown className="h-4 w-4 transition-transform duration-300 group-hover:translate-y-0.5" />
            {t.common.downloadSpec}
          </a>
        </Reveal>
      </div>
    </section>
  );
};

export default Products;
